<template>
  <div id="dialog-consulting-beneficiary">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="topics"
                  item-text="name"
                  item-value="idx"
                  label="Topic"
                  :readonly="true"
                  v-model="formData.consultingTopicId"
                ></v-autocomplete>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
                <v-textarea
                  clearable
                  label="Description"
                  v-model="formData.description"
                ></v-textarea>
                <v-text-field clearable label="Link" v-model="formData.link"></v-text-field>
                <v-text-field
                  clearable
                  data-vv-name="orders"
                  :error-messages="errors.collect('orders')"
                  label="Orders"
                  v-model="formData.orders"
                  v-validate="'numeric'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button
            :idx="formData.idx"
            module="ConsultingBeneficiary"
          ></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn @click.prevent="doSubmit()" color="green" dark :loading="dialogLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'dialog-consulting-beneficiary',
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ConsultingBeneficiary.idx) {
        this.formData = this.$store.getters['ConsultingBeneficiary/getAll'].filter(
          item => item.idx == this.$store.state.ConsultingBeneficiary.idx
        )[0]
      } else {
        this.formData = []
        if (this.$store.state.ConsultingTopic.idx) {
          this.formData.consultingTopicId = this.$store.state.ConsultingTopic.idx
        }
      }
    }
  },
  computed: {
    topics() {
      return this.$store.getters['ConsultingTopic/getAll']
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ConsultingBeneficiary.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ConsultingBeneficiary/UPDATE_DIALOG', newValue)
      }
    }
  },
  async created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            createdBy: localStorage.getItem('tokenAdmin')
          }
          this.formData.idx
            ? await this.$store.dispatch(`ConsultingBeneficiary/update`, data)
            : await this.$store.dispatch(`ConsultingBeneficiary/insert`, data)
          this.$store.commit(`ConsultingBeneficiary/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('ConsultingBeneficiary/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingBeneficiary/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
